import SectionTitle from '../common/SectionTitle';
import {
  ShieldCheck,
  Layers,
  Paintbrush,
  ChefHat,
  Bath,
  Zap,
  CheckCircle
} from 'lucide-react';

const Construction = () => {
  const sections = [
    {
      title: 'Structure & Safety',
      icon: ShieldCheck,
      items: [
        'RCC structure designed as per BIS seismic safety norms',
        'Reinforced concrete footings and columns for durability and strength'
      ]
    },
    {
      title: 'Flooring & Finishes',
      icon: Layers,
      items: [
        'Living & Dining: Superior quality vitrified tiles (800×800 mm)',
        'Bedrooms: Vitrified tiles (600×600 mm)',
        'Staircase: Kota stone / Indian stone flooring',
        'Toilets: Anti-skid ceramic tiles'
      ]
    },
    {
      title: 'Walls & Ceilings',
      icon: Paintbrush,
      items: [
        'Acrylic emulsion paint on POP punning',
        'Oil-bound distemper for ceilings',
        'Ceramic wall tiles in toilets up to dado level'
      ]
    },
    {
      title: 'Kitchen',
      icon: ChefHat,
      items: [
        'Anti-skid ceramic tile flooring',
        'Tiles up to 600 mm above kitchen counter',
        'Provision for modern fittings and appliances'
      ]
    },
    {
      title: 'Bathrooms',
      icon: Bath,
      items: [
        'Premium quality sanitary ware',
        'Granite counters',
        'Glass shower partitions',
        'Rain shower in master bathroom',
        'Sensor-based lighting',
        'CP fittings from Grohe / Kohler / Roca'
      ]
    },
    {
      title: 'Electrical & Utilities',
      icon: Zap,
      items: [
        'Concealed electrical wiring',
        'Provision for modern lighting and power points',
        'Well-planned drainage and utility systems'
      ]
    }
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          title="Construction & Quality Details"
          subtitle="Premium materials and superior craftsmanship"
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 mt-10 gap-8">
          {sections.map((section, idx) => {
            const Icon = section.icon;

            return (
              <div
                key={idx}
                className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-xl transition-all"
              >
                {/* Title */}
                <div className="flex items-center gap-3 mb-4">
                  <Icon size={26} className="text-emerald-600" />
                  <h3 className="text-xl font-bold text-gray-900">
                    {section.title}
                  </h3>
                </div>

                {/* Items */}
                <ul className="space-y-3">
                  {section.items.map((item, itemIdx) => (
                    <li
                      key={itemIdx}
                      className="flex items-start gap-3 text-sm text-gray-700"
                    >
                      <CheckCircle
                        size={18}
                        className="text-emerald-600 mt-0.5 shrink-0"
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Construction;
